import axios from 'axios'
import local from './localStorage.js'
import ElementUI from 'element-ui';

// 根据访问端口自动选择 baseURL:
// - 8080 端口 = webpack dev server (本地开发): 用 http://localhost:30408/dream/ 绕过 dev server
// - 80/443 端口 = 部署到服务器: 用 '/dream/' 相对路径走 nginx 反代
//
// 不需要 build 前手动改，运行时自动选
let baseURL
try {
  if (typeof window !== 'undefined' && window.location && window.location.port === '8080') {
    // dev 模式 (webpack dev server 默认 8080 端口)
    baseURL = 'http://localhost:30408/dream/'
  } else {
    // 生产: 用相对路径走 nginx /dream/ 反代到 127.0.0.1:30408
    baseURL = '/dream/'
  }
} catch (e) {
  baseURL = '/dream/'
}

var instance = axios.create({
	baseURL: baseURL,
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
	},
	transformRequest: [function(data) {
		let newData = ''
		for (let k in data) {
			if (data.hasOwnProperty(k) === true) {
				newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&'
			}
		}
		return newData
	}]
})

function apiAxios(method, url, params, response) {
	instance({
		method: method,
		url: url,
		data: method === 'POST' ? params : null,
		params: method === 'GET' ? params : null
	}).then(function(res) {
		if (res.status === 200) {
			if (res.data.status === 200) {
				response(res.data.data)
			} else {
				console.log(res.data)
				ElementUI.Message.error(res.data.msg)
			}
		} else {
			console.log(res.msg)
		}
	}).catch(function(err) {
		console.log(err)
		response(err)
	})
}

export default {
	apiAxios,
	get: function(url, params, response) {
		let token = local.getStorage('token')
		if (token !== undefined) {
			params.token = local.getStorage('token')
		}
		return apiAxios('GET', url, params, response)
	},
	post: function(url, params, response) {
		let token = local.getStorage('token')
		if (token !== undefined) {
			params.token = local.getStorage('token')
		}
		return apiAxios('POST', url, params, response)
	},
	uploadUrl: baseURL + '/upload/upload',
	baseURL: baseURL
}



//////////////////
// WEBPACK FOOTER
// ./http/api.js
// module id = null
// module chunks = 